module.exports = __webpack_public_path__ + "static/logo-tru-d157852dc14009da18a40cb6cfc13375.png";